export const contentDict = {
  title: "Catalyst",                // Display name
  finishDate: new Date("2023-09-17"),     // format is YYYY-MM-DD
  tools: {                                // Dict of languages and percentages (should add up to 1)
    "Python": 0.2,
    "TypeScript": 0.2, 
    "React": 0.2, 
    "Flask": 0.2, 
    "LangChain": 0.1, 
  }, 
  description: 
    `We transcribe video meetings, embed knowledge into a vector database and make the content searchable via chat. 
    [Won Sika's challenge](https://www.linkedin.com/feed/update/urn:li:activity:7110164700285296641/) at HackZurich 2023.`,
  tags: ["Knowledge Management", "LangChain", "HackZurich"],
  github: "https://github.com/hackzurich23/Catalyst",    // Can also be `null`
  website: null,       // Can also be `null`
  images: [
    "https://github.com/hackzurich23/Catalyst/raw/main/media/catalyst_video_third_res_4x_laptop.mp4",
    // "https://github.com/hackzurich23/Catalyst/raw/main/media/banner-square.jpg",
  ],
  coverImg: "https://github.com/hackzurich23/Catalyst/raw/main/media/banner-square.jpg",
  mainColor: "#000",
  authors: ["Philipp Wulff"],
  isResearch: false,    // Whether should be in the research section
};

// export default contentDict;
// module.exports = { contentDict: 'contentDict' }